import Vue from 'vue';
import { ObservableSet } from "../../../lib/utils/collections";
import { INJECT_PORTAL_CONTEXT } from './consts';
const PortalTarget = Vue.extend({
  name: 'PortalTarget',
  props: {
    name: {
      type: String,
      required: true
    },
    forceContext: {
      default: null
    }
  },
  data() {
    return {
      portals: new ObservableSet()
    };
  },
  inject: {
    normalContext: {
      from: INJECT_PORTAL_CONTEXT,
      default: null
    }
  },
  computed: {
    portalContext() {
      return this.forceContext || this.normalContext;
    }
  },
  created() {
    this.portalContext.portalTargets[this.name] = this;
  },
  beforeDestroy() {
    delete this.portalContext.portalTargets[this.name];
  },
  methods: {
    addPortal(portal) {
      this.portals.add(portal);
    },
    removePortal(portal) {
      this.portals.delete(portal);
    }
  },
  render(h) {
    const children = Array.from(this.portals.values(), x => {
      var _x$$slots;
      return h('div', {
        key: x.portalId,
        ref: `portal:${x.portalId}`,
        attrs: {
          'data-portal-id': x.portalId
        }
      }, (_x$$slots = x.$slots) === null || _x$$slots === void 0 ? void 0 : _x$$slots.default);
    });
    return h('div', {
      class: 'ucdPortalTarget',
      staticStyle: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%'
      }
    }, children);
  }
});
export default PortalTarget;
//# sourceMappingURL=PortalTarget.js.map
